// extracted by mini-css-extract-plugin
export default {"screenXLMin":"1279px","header":"styles_header__9-S88","sticky":"styles_sticky__mJbaG","right-part-container":"styles_right-part-container__WsLLQ"};